module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/64.a7aeb05e.png";